import { createContext, useContext, useState } from "react"

const FiltersContext = createContext()

export const FiltersProvider = ({ children }) => {
  const [filters, setFilters] = useState()

  const handleChange = ({ type, key, value }) => {
    const typeValue = !key ? value : { ...filters[type], [key]: value }
    setFilters(prevFilters => ({ ...prevFilters, [type]: typeValue }))
  }

  return (
    <FiltersContext.Provider value={{ filters, setFilters, handleChange }}>
      {children}
    </FiltersContext.Provider>
  )
}

export const useFilters = () => useContext(FiltersContext)
